import { render, staticRenderFns } from "./RobotBase.vue?vue&type=template&id=3ce025d8"
import script from "./RobotBase.vue?vue&type=script&lang=js"
export * from "./RobotBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports